import GenericFaqAccordion, { FaqItem } from "@/components/generic-faq-accordion";

const paragraphs = [
  "Michigan Manufacturing International (MMI) is one of the established contract manufacturing companies supporting OEMs across industrial and heavy-engineering sectors. Headquartered in Stevensville, Maryland, MMI provides component, assembly, and complete product manufacturing through a global network of approved production facilities and supply management operations.",
  "MMI works with customers in electric power, commercial vehicles, construction equipment, mining, oil and gas, agricultural equipment, consumer appliances, pumps and compressors, packaging equipment, and general industrial machinery. Manufacturing is executed to customer drawings and specifications, with support spanning design-for-manufacture, prototyping, production, machining, assembly, inspection, and delivery.",
  "Among global contract manufacturing companies, MMI offers a broad manufacturing portfolio that includes ferrous and non-ferrous casting, CNC machining, molding, tube bending, stamping, forging, finishing operations, and mechanical assembly and fabrication. Casting capabilities include die casting, sand casting, investment casting, and permanent mold casting, while machining and fabrication services are supported by established quality and process controls.",
  "As a global CNC machining manufacturer, MMI supports OEM requirements through established machining capabilities integrated with casting, fabrication, assembly, and supply chain operations. Production is supported by wholly owned facilities in India and supplier coordination across China, Vietnam, South Korea, and Malaysia. This network enables MMI to manage sourcing, manufacturing, process control, and logistics through a unified operating model. Inventory management services include ISO-certified warehousing, FIFO control, batch traceability, safety stock management, and customer-defined release protocols.",
  "Quality remains central to MMI's operations. Every project is manufactured to approved drawings and control plans, with dimensional inspections, material test reports (MTRs), and final inspection documentation maintained throughout the production cycle. The company supports customers seeking reliable supply chain management alongside manufacturing execution.",
  "For organizations evaluating contract manufacturing companies, MMI combines engineering support, manufacturing capabilities, inventory management, and global logistics under a single point of coordination. With manufacturing locations in Chennai, Coimbatore, and Hosur, alongside its Maryland headquarters and international supply operations, MMI provides manufacturing support designed around customer specifications and operational requirements.",
];

const faqs: FaqItem[] = [
  {
    question: "What industries does Michigan Manufacturing International serve?",
    answer:
      "MMI serves industries including electric power, commercial vehicles, construction equipment, mining, oil and gas, agricultural equipment, consumer appliances, and industrial machinery.",
  },
  {
    question: "What manufacturing capabilities does MMI provide?",
    answer:
      "MMI offers casting, CNC machining, molding, tube bending, stamping, forging, finishing, and mechanical assembly and fabrication services.",
  },
  {
    question: "Where are MMI's manufacturing operations located?",
    answer:
      "MMI is headquartered in Stevensville, Maryland, with manufacturing facilities in Chennai, Coimbatore, and Hosur, and supply management operations across China, Vietnam, South Korea, and Malaysia.",
  },
  {
    question: "Does MMI provide inventory management services?",
    answer:
      "Yes. MMI provides ISO-certified warehousing, FIFO inventory control, batch traceability, safety stock management, and customer-specific release protocols.",
  },
  {
    question: "Does MMI manufacture based on standard products or customer specifications?",
    answer:
      "MMI manufactures components and assemblies according to customer drawings, specifications, material requirements, and approved quality control plans.",
  },
];

export default function HomepageSeoContent() {
  return (
    <section className="mx-auto w-full max-w-[1320px] px-4 py-10 md:px-6 md:py-16">
      <div className="text-left">
        <h2 className="text-2xl font-semibold text-[var(--mmi-heading)] sm:text-3xl md:text-4xl">
          Global Precision Manufacturing Partner for Industrial OEMs
        </h2>
        <div className="mt-4 h-1 w-24 bg-[var(--brand-yellow)]" />
      </div>

      <div className="mt-6 space-y-4 text-base leading-relaxed text-[var(--mmi-body)] sm:text-lg">
        {paragraphs.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 md:gap-10 lg:grid-cols-2">
        <div>
          <h3 className="mb-3 text-2xl font-bold text-black sm:text-3xl">
            FAQs:
          </h3>
          <p className="text-base leading-relaxed text-muted-foreground sm:text-lg">
            Find answers to common questions about MMI&apos;s manufacturing capabilities and global supply network.
          </p>
        </div>
        <div className="mt-2 md:mt-3">
          <GenericFaqAccordion faqs={faqs} />
        </div>
      </div>
    </section>
  );
}
